/**
 * require.context(directory, useSubdirectories, regExp)
 * directory：表示检索的目录
 * useSubdirectories：表示是否检索子文件夹
 * regExp：匹配文件的正则表达式，一般是文件名
 */
import zh_cn from '../zh-cn';

const requireAll = requireContext => {
  try {
    return requireContext.keys().map(key => {
      try {
        return requireContext(key);
      } catch (error) {
        console.error(`Failed to load module ${key}:`, error);
        return {};
      }
    });
  } catch (error) {
    console.error('Failed to load modules:', error);
    return [];
  }
};

const req = require.context('./module/', true, /\.js$/);
let en_us = {};

try {
  const modules = requireAll(req);
  if (modules.length > 0) {
    modules.forEach(item => {
      Object.assign(en_us, item.default);
    });
  } else {
    console.warn('No modules found in ./module/');
  }
} catch (error) {
  console.error('Error processing modules:', error);
}

export default en_us;
